import { Box, Divider, Typography, useTheme } from "@mui/material";
import CustomerLogo from "Images/CustomerLogo.png";
import { useSelector } from "react-redux";
import { selectCustomerLogo, selectHeaderText, selectSubheaderText } from "slices/customerThemeSlice";

export default function Footer() {
  const theme = useTheme();
  const dynamicLogo = useSelector(selectCustomerLogo) || CustomerLogo;
  const headerText = useSelector(selectHeaderText);
  const subheaderText = useSelector(selectSubheaderText);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignSelf: "flex-end",
        alignItems: "center",
        backgroundColor: theme.palette.secondary.main,
        py: { xs: 3, sm: 4 },
        px: { xs: 2, sm: 8 },
      }}
    >
      <Box maxWidth="lg" sx={{ width: "100%" }}>
        <Divider sx={{ borderColor: theme.palette.grey.main }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 2, sm: 7 },
            mx: { xs: 0, sm: 4 },
            pt: 4,
          }}
        >
          <Box component="img" sx={{ content: `url(${dynamicLogo})`, height: { xs: "40px", sm: "56px" } }}></Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", sm: "flex-start" },
              textAlign: { xs: "center", sm: "start" },
            }}
          >
            <Typography variant="h1">{headerText}</Typography>
            <Typography
              variant="p"
              sx={{ display: { xs: "none", sm: "block" }, mt: 1, color: theme.palette.text.light }}
            >
              {subheaderText}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
